import UlPage from './main.vue'

UlPage.install = function (_Vue) {
  _Vue.component(UlPage.name, UlPage)
}

export default UlPage